import { FC, Fragment, useEffect, useState } from 'react';
import { Box, Divider, List, Typography } from '@mui/material';
import { useGetMessagesQuery } from '../../graphql/generated/operations/messages.ts';
import { LoadingBackdrop } from '../../components/loading.backdrop.tsx';
import { MessageListItem } from '../../components/messages/message-list-item.tsx';
import { useNotifications } from '../../contexts/notification.context.tsx';
import { isPast } from 'date-fns';

export const MessageListPage: FC = () => {
  const { loading, data } = useGetMessagesQuery({
    fetchPolicy: 'network-only',
    variables: {
      offset: Math.floor(new Date().getTimezoneOffset() / 60) // Timezone offset in hours
    }
  });
  const [messages, setMessages] = useState<any[]>([]);
  const { updateNotificationCount } = useNotifications();

  useEffect(() => {
    updateNotificationCount();
  }, []);

  useEffect(() => {
    if (data) {
      let messages = [...(data.notifications || [])];
      messages = messages.filter((n) => {
        return isPast(n.scheduledAt);
      });
      messages.sort((a, b) => {
        return new Date(b.scheduledAt).getTime() - new Date(a.scheduledAt).getTime();
      });
      setMessages(messages as any);
    }
  }, [data]);

  if (loading) {
    return <LoadingBackdrop />;
  }

  if (messages.length === 0) {
    return <Typography variant="h4">No messages</Typography>;
  }
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Messages
      </Typography>
      <Divider />
      <List>
        {messages.map((n) => (
          <Fragment key={n._id}>
            <MessageListItem notification={n} />
            <Divider />
          </Fragment>
        ))}
        <Box sx={{ mt: 10 }} />
      </List>
    </>
  );
};
